import {
  PrinterSortOption,
  enumPrinterStatus,
  enumPrinterType,
} from '@rematter/frontend-lib-api-client';

import { PrinterRecord } from '../types/sidecar';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { parseZonedDateTime } from '~/shared/utils/dateTime';

export const printersListQueryAtom = createQueryAtomFactory(
  'settings.printersList',
  (params: {
    ids?: string[];
    sidecarId?: string;
    limit?: number;
    offset?: number;
    sorting?: PrinterSortOption[];
  }) => ({
    printers: {
      __args: {
        filter: {
          ids: params.ids,
          sidecarId: params.sidecarId,
        },
        sorting: params.sorting,
        pagination: {
          limit: params.limit ?? 50,
          offset: params.offset ?? 0,
        },
      },
      entries: {
        id: true,
        sidecarId: true,
        uniqueId: true,
        driverType: true,
        name: true,
        manufacturer: true,
        model: true,
        firmwareVersion: true,
        printerType: true,
        status: true,
        online: true,
        lastSeenAt: true,
        sidecar: {
          id: true,
          name: true,
        },
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data): { printers: PrinterRecord[]; totalCount: number } => {
      if (!data?.printers?.entries) {
        return { printers: [], totalCount: 0 };
      }

      return {
        printers: data.printers.entries.map((entry) => ({
          id: entry.id,
          sidecarId: entry.sidecarId,
          uniqueId: entry.uniqueId,
          driverType: entry.driverType,
          name: entry.name,
          manufacturer: entry.manufacturer ?? null,
          model: entry.model ?? null,
          firmwareVersion: entry.firmwareVersion ?? null,
          printerType: entry.printerType ?? enumPrinterType.Standard,
          pageSize: null,
          rollWidth: null,
          status: entry.status ?? enumPrinterStatus.Discovered,
          online: entry.online ?? false,
          lastSeenAt: entry.lastSeenAt
            ? parseZonedDateTime(entry.lastSeenAt)
            : null,
          sidecar: entry.sidecar
            ? {
                id: entry.sidecar.id,
                name: entry.sidecar.name,
              }
            : null,
          timestamps: {
            createdAt: parseZonedDateTime(entry.timestamps.createdAt),
            updatedAt: parseZonedDateTime(entry.timestamps.updatedAt),
          },
        })),
        totalCount: data.printers.page?.total ?? 0,
      };
    },
  },
);
